<template>
    <label class="opui-form-label-top">{{ $e('Only if') }}</label>

    <div v-if="item.settings.rows && item.settings.rows.length">
        <FilterRow v-for="(row, index) in item.settings.rows" :row="row" :workflow="workflow" :item="item" :index="index" @remove="removeRow" />
    </div>

    <a href="#" @click.prevent="addNew" class="opui-d-block opui-fs-6 opui-my-3">+ {{ $e('Add new filter') }}</a>
</template>

<script>
import FilterRow from "../Filters/FilterRow.vue";

export default {
    components: {FilterRow},
    props: {
        item:     { type: Object, required: true },
        workflow: { type: Object, required: true },
    },
    data() {
        return {

        }
    },
    mounted() {
        // Check if no rows, add a default one
        if (! this.item.settings.rows || ! this.item.settings.rows.length) {
            this.item.settings.rows = [
                { operator: 'equals', operator_title: 'equals', id: this.randomUid() }
            ]
        }

        this.validate()
    },
    methods: {
        addNew() {
            // Add a new row
            this.item.settings.rows.push({ operator: 'equals', operator_title: 'equals', id: this.randomUid() })
        },

        removeRow(row) {
            this.item.settings.rows = this.item.settings.rows.filter((value, index, arr) => {
                return value.id !== row.id
            })
        },

        /**
         * Validate rows and enable save button
         */
        validate() {
            this.item.validated = true
        }
    }
}
</script>
